import "./App.css";
import Header from "./header";
import Home from "./home";
import Footer from "./footer";
import Share from "./share";
import PartnerShip from "./partnership";
import Family from "./family";
import { Element } from "react-scroll";
function App() {
  return (
    <div>
      <Element name="header">
        <Header />
      </Element>
      <Element name="home">
        <Home />
      </Element>
      <Element name="whypartnership">
        <Share />
      </Element>
      {/* <Element name="applypartnership">
        <PartnerShip />
      </Element> */}
      <Element name="officialpartners">
        <Family />
      </Element>
      <Element name="footer">
        <Footer />
      </Element>
    </div>
  );
}

export default App;
